import { Component, OnInit,  TemplateRef, ViewChild, Input, Output, EventEmitter  } from '@angular/core';
import { TopnavService } from '../header/topnav/topnav.service';
import {SharedService } from '../common/shared.service';
import { Router, NavigationEnd } from '@angular/router';
import { NavService } from '../header/nav/nav.service';
import * as $ from 'jquery';

let num = 0;

/**
 * Author: Sridhar Swaminathan
 * 
 * Date Created: December 8th 2017
 * 
 * Description: Component class for Side Navigation Main Page.
 **/
@Component({
  selector: 'gosg-sidenavmain',
  templateUrl: './sidenavmain.component.html',
  styleUrls: [
    './sidenavmain.component.css'
  ]
})
export class SidenavmainComponent implements OnInit {
  defaultColors: any;
  defaultFonts: any;
  fontTy(arg0: any): any {
    throw new Error("Method not implemented.");
  }
  getThemeColors: any;
  getThemeFonts: any;
  translatedText: string;
  supportedLanguages: any[];
  colors: any[];
  selectedRow: Number;
  firstItem: boolean;
  minusBtn = false;
  plusBtn = false;
  admin: boolean;
  langId = this.langId;
  panelOpenState: any;
  @Output() openSlide:EventEmitter<string> = new EventEmitter();
  customFontType: any;
  public fontSize: any = {
    "sizeS" : "14px",
    "sizeM" : "19px",
    "sizeL" : "23px",
    "no_styles" : "0.9em"
  };
  constructor(
    private navService: NavService,
    private router: Router,
    private topnavservice: TopnavService,
    private sharedservice: SharedService
  ) {

    this.sharedservice.fontTypeData.subscribe((data)=>{
      this.customFontType = data;
    });

    this.sharedservice.fontSizeData.subscribe((data)=>{
      this.fontSize = data;
    });

    this.sharedservice.currFontNum.subscribe((data)=>{
      num = data;
      if (data == 0) {
        this.minusBtn = false;
        this.plusBtn = false;
      } else if (data < -2) {
        this.minusBtn = true;
        this.plusBtn = false;
      }else if (data > 2) {
        this.plusBtn = true;
        this.minusBtn = false;
      }
    });
  }

  ngOnInit() {

    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      this.closeNav();
      window.scrollTo(0, 0);
    });

    this.colors = this.topnavservice.getColors();

    //load font
    this.sharedservice.themefontData.subscribe((data)=>{
      if (data) {
        this.getThemeFonts = data;
      }
    });

    //load colors
    this.sharedservice.themefontData.subscribe((data)=>{
      if (data) {
        this.getThemeColors = data;
      }
    });

      //this.loadFont(); 
      //this.loadColor();
      // this.loadDefaultFonts();
      // this.loadDefaultColor();   
    
  }

  callApi(){
    
    this.loadFont(); 
    this.loadColor();
    // this.loadDefaultFonts();
    // this.loadDefaultColor(); 
  }

  openNav() {
    document.getElementById("mySidenav").style.width = "250px";
  }

  closeNav() {
    document.getElementById("mySidenav").style.width = "0";
  }

  setClickedColor(index, firstItem) {
    localStorage.setItem('themeColor', firstItem);
    $('#confBar1 .settingBtm input').removeClass('colorPaletteActive');
    $('#confBar1 .settingBtm input:nth('+index+')').addClass('colorPaletteActive');
    localStorage.setItem('themeIndex', index);
    this.selectedRow = index;
    this.firstItem = firstItem;
    this.sharedservice.setBgColorData(firstItem);
  }

  ngAfterViewInit() {
    this.loadCustomFontType();
  }

  loadCustomFontType(){
    if (localStorage.getItem('customFontType')) {
      $('body, .font-size-s, .font-size-m, .font-size-l, .font-size-xl, .font-size-xxl, .mat-tab-label, .mat-tab-link').css('font-family', localStorage.getItem('customFontType'));
      $('#fontOptSideMenu2 option[value="' + localStorage.getItem('customFontType') + '"]').attr('selected', 'selected');
      $('#fontOptSideMenu2').val(localStorage.getItem('customFontType'));
      this.sharedservice.setFontType(localStorage.getItem('customFontType'));
      this.customFontType = localStorage.getItem('customFontType');
    }
    if (localStorage.getItem('themeIndex')) {
      $('#confBar1 .settingBtm input').removeClass('colorPaletteActive');
      $('#confBar1 .settingBtm input:nth('+localStorage.getItem('themeIndex')+')').addClass('colorPaletteActive');
      localStorage.setItem('themeIndex', localStorage.getItem('themeIndex'));
    }
    /*if (localStorage.getItem('customFontSize')) {
      let dynum = parseInt(localStorage.getItem('customFontSize'));
              $('.font-size-s').css('font-size', 14 + dynum + 'px');
              $('.font-size-m').css('font-size', 19 + dynum + 'px');
              $('.font-size-l').css('font-size', 23 + dynum + 'px');
              $('.mat-tab-label').css('font-size',14 + dynum + 'px');
              $('.no-styles').css('font-size',0.9 + dynum*0.1 + 'em');
              $('.mat-form-field-placeholder').css('font-size', 14 + dynum + 'px');
    } */
  }

  resetBgColor() {

    this.sharedservice.getThemeColor().subscribe(
      data => {
        this.defaultColors = data;
        data.filter((color, index)=>{
          if(color.defaultColor == true){
            localStorage.setItem('themeColor', color.colorCode);
            localStorage.setItem('themeIndex', index);
            $('#confBar1 .settingBtm input').removeClass('colorPaletteActive');
            $('#confBar1 .settingBtm input:nth('+index+')').addClass('colorPaletteActive');
            this.sharedservice.setBgColorData(color.colorCode);
          }
        })
      }, err => {

      })
  }

  fontminus() {
    this.plusBtn = false;
    num = num - 1;
    this.fn_changeFont(num);
    this.sharedservice.currFontNum.next(num);
    if (num <= -3) {
      this.minusBtn = true;
      this.plusBtn = false;
    } else if (num > -3) {
      this.minusBtn = false;
      //this.plusBtn = true
    }
  }

  fontplus() {
    this.minusBtn = false;
    num = num + 1;
    this.fn_changeFont(num);
    this.sharedservice.currFontNum.next(num);
    if (num >= 3) {
      this.plusBtn = true;
      this.minusBtn = false;
    } else if (num < 3) {
      this.plusBtn = false;
      //this.minusBtn = true
    }
  }

  fontreset() {
    this.minusBtn = false;
    this.plusBtn = false;
    num = 0;
    this.fn_changeFont(num);
    this.sharedservice.currFontNum.next(num);
  }

  loadFont(){
    this.sharedservice.getThemeFont().subscribe(
      data => {
        this.getThemeFonts = data;
      }, err => {

      })
  }

  loadDefaultFonts(){
    this.sharedservice.getThemeFont().subscribe(
      data => {
        this.defaultFonts = data;
        data.filter(function(font){
          if(font.defaultFont == true){
            if (!localStorage.getItem('customFontType')) {
              $('body, .font-size-s, .font-size-m, .font-size-l, .font-size-xl, .font-size-xxl, .mat-tab-label, .mat-tab-link').css('font-family', font.fontName);
            }
            
          }
        })
      }, err => {

      })
  }

  loadColor(){
    this.sharedservice.getThemeColor().subscribe(
      data => {
        this.getThemeColors = data;
      }, err => {

      })
  }

  loadDefaultColor(){
    this.sharedservice.getThemeColor().subscribe(
      data => {
        this.defaultColors = data;
        data.filter(function(color, index){
          if(color.defaultColor == true){
            if (!localStorage.getItem('themeColor')) {
              localStorage.setItem('themeColor', color.colorCode);
              localStorage.setItem('themeIndex', index);
              $('#confBar1 .settingBtm input').removeClass('colorPaletteActive');
              $('#confBar1 .settingBtm input:nth('+index+')').addClass('colorPaletteActive');
            }
          }
        })
      }, err => {

      })
  }

  fn_changeFont(dynum) {
    $('.font-size-s').css('font-size', 14 + dynum + 'px');
    $('.font-size-m').css('font-size', 19 + dynum + 'px');
    $('.font-size-l').css('font-size', 23 + dynum + 'px');
    $('.mat-tab-label').css('font-size',14 + dynum + 'px');
    $('.no-styles').css('font-size',0.9 + dynum*0.1 + 'em');
    $('.mat-form-field-placeholder').css('font-size', 14 + dynum + 'px');
    $('.font-size-s > table td').css('font-size', 14 + dynum + 'px');
    $('.font-size-s > table th').css('font-size', 14 + dynum + 'px');
    localStorage.setItem('customFontSize', dynum);
  }


  onChange($event, deviceValue) {
    $('body, .font-size-s, .font-size-m, .font-size-l, .font-size-xl, .font-size-xxl, .mat-tab-label, .mat-tab-link').css('font-family', deviceValue);
    localStorage.setItem('customFontType', deviceValue);
    this.sharedservice.setFontType(deviceValue);
  }

  resetFontStyle() {

    this.sharedservice.getThemeFont().subscribe(
      data => {
        this.defaultFonts = data;
        data.filter((font)=>{
          if(font.defaultFont == true){
            $('#fontOptSideMenu2').val(font.fontName);
            $('body, .font-size-s, .font-size-m, .font-size-l, .font-size-xl, .font-size-xxl, .mat-tab-label, .mat-tab-link').css('font-family', font.fontName);
            localStorage.setItem('customFontType', font.fontName);
            this.sharedservice.setFontType(font.fontName);
          }
        })
      }, err => {

      })
  }

}



// WEBPACK FOOTER //
// ./src/app/sidenavmain/sidenavmain.component.ts